module.exports = __webpack_public_path__ + "static/media/download-area-bottom.131b02a6.png";